import { render, staticRenderFns } from "./RegistroPontoModal.vue?vue&type=template&id=0702fd1a&"
import script from "./RegistroPontoModal.vue?vue&type=script&lang=js&"
export * from "./RegistroPontoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports